var map = {
	"./ad1.jpg": 2783,
	"./ad2.jpg": 9641,
	"./ad3.jpg": 7329,
	"./logo.png": 4427,
	"./review1.jpg": 7072,
	"./review2.jpg": 3471,
	"./review3.jpg": 106,
	"./wf-ad1.jpg": 7416,
	"./wf-ad2.jpg": 5396,
	"./wf-ad3.jpg": 3205
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;